module.exports = __webpack_public_path__ + "media/src/images/arrow__buttonDown--dark-c154fc6a7aa382d053d9cf2b6bb69966.png";